import { Typography } from '@material-ui/core'
import React from 'react'
import { Row, Col } from 'react-bootstrap'

export default function renderHelpAdminCupos () {
  return (
    <Row>
      <Col md={6} style={{ padding: '0 22px' }}>
        <h3>Asignación de cupos</h3>
        <Typography>En la interfaz de asignación de cupos ud. puede realizar una asignación de cupos nominables o libres para un determinado Exportador.<br /><br />

                - Fecha de emisión: Indica la fecha de inicio de vigencia del cupo.<br />
                - Tipo de cupo: Indica el tipo de cupo. Puede ser nominable o libre.<br />
                - Cereal: Indica a qué cereal pertenecerá el cupo.<br />
                - Exportador: Indica a qué exportador pertenecerá el cupo.<br />
                - Cantidad: Indica la cantidad de cupos a asignar. <br /><br />

                En la parte inferior se muestran 2 listados. El primero contiene el listado de cupos asignados vigentes.
                En el listado existe la columna 'Operación' donde figuran las operaciones disponibles para cada cupo.
        </Typography>
      </Col>
      <Col md={6} style={{ padding: '0 22px' }}>
        <h3>Nominación de cupos</h3>
        <Typography>En la interfaz de asignación de cupos ud. puede realizar una asignación de cupos nominables o libres para un determinado Exportador.<br /><br />

                - Fecha de emisión: Indica la fecha de inicio de vigencia del cupo.<br />
                - Tipo de cupo: Indica el tipo de cupo. Puede ser nominable o libre.<br />
                - Cereal: Indica a qué cereal pertenecerá el cupo.<br />
                - Exportador: Indica a qué exportador pertenecerá el cupo.<br />
                - Cantidad: Indica la cantidad de cupos a asignar. <br /><br />

                En la parte inferior se muestran 2 listados. El primero contiene el listado de cupos asignados vigentes.
                En el listado existe la columna 'Operación' donde figuran las operaciones disponibles para cada cupo.
        </Typography>
      </Col>
    </Row>
  )
}

export const renderHelpAdminCereales = () => {
  return (
    <Row>
      <Col md={12} style={{ padding: '0 22px' }}>
        <h3>Asignación de cupos</h3>
        <Typography>En la interfaz de asignación de cupos ud. puede realizar una asignación de cupos nominables o libres para un determinado Exportador.<br /><br />

                - Fecha de emisión: Indica la fecha de inicio de vigencia del cupo.<br />
                - Tipo de cupo: Indica el tipo de cupo. Puede ser nominable o libre.<br />
                - Cereal: Indica a qué cereal pertenecerá el cupo.<br />
                - Exportador: Indica a qué exportador pertenecerá el cupo.<br />
                - Cantidad: Indica la cantidad de cupos a asignar. <br /><br />

                En la parte inferior se muestran 2 listados. El primero contiene el listado de cupos asignados vigentes.
                En el listado existe la columna 'Operación' donde figuran las operaciones disponibles para cada cupo.
        </Typography>
      </Col>
    </Row>
  )
}

export const renderHelpPenalizacion = () => {

}
